import React from "react"
import ErrorLoading from "./ErrorLoading"
import CourseCurriculum, { Loading } from "./CourseCurriculum"
import { useMembershipJourney } from "../../../hooks/useMembershipJourney"
import { useRefetch } from "../../../hooks/useRefetch"
import { MembershipJourneyProvider } from "../MembershipJourney/MembershipJourneyContext"

export const CourseCurriculumWrapper = () => {
  const { person, loading, error, refetch } = useMembershipJourney()
  const { isFetching, reload } = useRefetch()

  if (loading || isFetching) {
    return <Loading />
  }

  if (error || !person) {
    return <ErrorLoading refetch={refetch} reload={reload} />
  }

  const contextValue = {
    pgaId: person?.pgaId || person?.id,
    pgmProgress: person?.pgmProgress,
    me: person,
  }

  return (
    <MembershipJourneyProvider value={contextValue}>
      <CourseCurriculum />
    </MembershipJourneyProvider>
  )
}

export default CourseCurriculumWrapper
